import { useState, useCallback, useRef } from 'react';
import Cookies from 'universal-cookie';

export default function useCookie(name, defaultValue) {
  // Use a ref so the Cookies instance is stable across renders (avoids stale closure in callbacks)
  const cookiesRef = useRef(new Cookies(null, { path: '/' }));
  const cookies = cookiesRef.current;

  const [value, setValue] = useState(() => {
    const cookie = cookies.get(name);
    if (cookie) return cookie;
    cookies.set(name, defaultValue);
    return defaultValue;
  });

  const updateCookie = useCallback(
    (name, newValue, options = {}) => {
      // Cookie expiry matches the JWT lifetime (24 hours)
      const defaultOptions = {
        expires: new Date(Date.now() + 24 * 60 * 60 * 1000), // 24 hours
        ...options
      };
      cookies.set(name, newValue, defaultOptions);
      setValue(newValue);
    },
    [name]
  );

  const deleteCookie = useCallback(() => {
    cookies.remove(name, { path: '/' });
    setValue(false);
  }, [name]);

  return [value, updateCookie, deleteCookie]
}